import { programAPI } from 'api/program';
import { ProgramDto } from 'dto/program';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: ProgramDto) => void;
};

export function useFindOneProgram(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_PROGRAM, props.id],
    queryFn: () => programAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
